import { useBloomreachPageModels } from "./use-bloomreach-page-models.js";
const useBloomreachSiteLogos = () => {
  const models = useBloomreachPageModels();
  if (!models) {
    return {};
  }
  return {
    main: models.logoUrl,
    small: models.logoSmallUrl,
    mobile: models.logoMobileUrl,
    alternative: models.logoAlternativeUrl,
    reimbursable: models.reimbursableLogoUrl,
    reimbursableAlternative: models.reimbursableLogoAlternativeUrl,
    payInstallmentsLogo: models.payInstallmentsLogoUrl,
    logoFooter: models.logoFooter
  };
};
export {
  useBloomreachSiteLogos
};
//# sourceMappingURL=use-bloomreach-site-logos.js.map
